<template>
  <p v-if="smart" class="smart">
    <span data-test-id="smart-content">
      {{ truncatedText }}
    </span>
  </p>
</template>

<script>
import { truncateText } from '~~/common/js/universal/utils';

export const TEXT_TRUNCATE_LENGTH = 240;

export default {
  props: {
    smart: {
      type: String,
      default: '',
    },
  },
  computed: {
    truncatedText() {
      return truncateText(this.smart, TEXT_TRUNCATE_LENGTH);
    },
  },
};
</script>

<style lang="scss" scoped>
.smart {
  @extend %ellipsis;

  margin: 0;
}
</style>
